import $ from 'jquery';
import dom from './dom';
import 'owl.carousel';
import 'jquery-mousewheel';

const carousel = () => {
  const $navText = [
    '<i class="icon-chevron-left"></i>',
    '<i class="icon-chevron-right"></i>',
  ];
  const owl = $('.owl-carousel.c-archive__love-list');
  const options = {
    margin: 0,
    stagePadding: 25,
    autoHeight: true,
    dots: false,
    nav: true,
    navText: $navText,
    lazyLoad: true,
    responsive: {
      0: {
        margin: 35,
        autoHeight: true,
        autoWidth: true,
      },
      768: {
        margin: 32,
        autoHeight: false,
        autoWidth: true,
      },
      1024: {
        margin: 32,
        autoHeight: false,
        autoWidth: false,
      },
      1240: {
        autoWidth: false,
        items: 4,
        stagePadding: 0,
      },
      1400: {
        margin: 50,
        autoHeight: false,
        autoWidth: true,
      },
    },
  };
  const moveNav = () => {
    setTimeout(() => {
      const nav = owl.find('.owl-nav');
      const wrapper = owl.closest('.c-archive__love-content');
      if (nav.length && wrapper.length) {
        $(wrapper.find('.c-archive__love-title')).append(nav);
      }
    });
  };
  owl.on('initialized.owl.carousel', () => {
    moveNav();
  });
  owl.owlCarousel(options);

  const $postsPerPage = owl.data('posts-per-page');
  const $exclude = owl.data('exclude');
  const $cat = owl.data('cat');
  let isLoading = false;
  owl.on('changed.owl.carousel', () => {
    const $offset = owl.data('offset');
    if (!isLoading) {
      isLoading = true;
      const data = {
        action: 'ajax_get_more_latest_stories',
        offset: $offset,
        exclude: $exclude,
        posts_per_page: $postsPerPage,
      };
      if ($cat) {
        data.cat = $cat;
      }
      $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data,
        success: res => {
          const $res = JSON.parse(res);
          const newOffset = $res.offset;
          owl.data('offset', newOffset);
          owl.attr('data-offset', newOffset);
          $.each($res.html, (index, val) => {
            owl.trigger('add.owl.carousel', [$(val)]);
          });
          owl.trigger('refresh.owl.carousel');
          dom.$doc.trigger('updateTrunc');
          isLoading = false;
        },
      });
    }
  });

  const archiveNews = $('.owl-carousel.c-archive__news-list');
  if (archiveNews.length) {
    const optionsArchiveNews = {
      items: 1,
      margin: 0,
      stagePadding: 165,
      dots: false,
      autoWidth: true,
      nav: true,
      navText: $navText,
    };
    const initArchiveNews = () => {
      if (dom.$win.width() > 999) {
        archiveNews.trigger('destroy.owl.carousel');
      } else {
        if (dom.$win.width() > 767) {
          optionsArchiveNews.items = 2;
          optionsArchiveNews.stagePadding = 0;
        } else {
          optionsArchiveNews.items = 1;
          optionsArchiveNews.stagePadding = 165;
        }
        archiveNews.owlCarousel(optionsArchiveNews);
      }
    };

    initArchiveNews();
    dom.$win.on('resize', () => {
      initArchiveNews();
    });
  }

  const owlGuides = $('.owl-carousel.c-essential-guides__list');
  const optionsGuides = {
    margin: 20,
    dots: false,
    autoWidth: true,
    navText: $navText,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      2550: {
        items: 3,
        nav: false,
      },
    },
  };

  owlGuides.owlCarousel(optionsGuides);
};
export default carousel;



// WEBPACK FOOTER //
// ./src/scripts/modules/carousel.js